<div class="smart-assistant-object-container">
    <div class="object-icon-and-label" nTextTips>
        <!-- 图标 -->
        <svg *ngIf="icon" class="icon">
            <use [attr.xlink:href]="icon"></use>
        </svg>
        <!-- Label -->
        <span class="object-label">{{name}}</span>
    </div>
    <!-- 操作按钮 -->
    <button nButton theme="text" (click)="clickBtn()" [label]="operateLabel"></button>
</div>
